import { useSelector } from "react-redux";
import { NavLink, Outlet, useLocation } from "react-router-dom";
import "./admin.scss";
import Breadcrumb from "components/Breadcrumb/Breadcrumb";
import { withUser } from "hoc/withUser";
import UserMenu from "components/UserMenu/UserMenu";
import { getAuthUser } from "redux/selectors/getUser";
import {
  MdOutlinePlayLesson,
  MdOutlineModeComment,
  MdOutlineEvent,
  MdLocalActivity,
} from "react-icons/md";
import { useEffect, useRef } from "react";
import { Collapse, IconButton, List, ListItemButton } from "@mui/material";
import { FaBars } from "react-icons/fa";
import { ListItemIcon } from "@mui/material";
import { ListItemText } from "@mui/material";

const SuperAdminLayout = () => {
  // useCheckAuth([roleEnum.admin]);
  const authUser = useSelector(getAuthUser);
  const sidebar = useRef(null);
  const burger = useRef(null);
  const location = useLocation();

  const menu = [
    {
      icon: MdOutlinePlayLesson,
      path: "allah-names",
      label: "Имена Аллаха",
    },
    {
      icon: MdOutlinePlayLesson,
      path: "stats",
      label: "Аналитика",
    },
    {
      icon: MdOutlinePlayLesson,
      path: "organizations",
      label: "Организации",
    },
    {
      icon: MdLocalActivity,
      path: "marketplace",
      label: "Управление товарами",
      children: [
        {
          icon: MdLocalActivity,
          path: "marketplace/products",
          label: "Товары",
        },
        {
          icon: MdLocalActivity,
          path: "marketplace/categories",
          label: "Категории товаров",
        },
        {
          icon: MdLocalActivity,
          path: "marketplace/vendors",
          label: "Производители",
        },
        {
          icon: MdLocalActivity,
          path: "marketplace/returns",
          label: "Возвраты",
        },
      ]
    },
    {
      icon: MdOutlinePlayLesson,
      path: "countries",
      label: "Страны и городы",
    },
    {
      icon: MdOutlinePlayLesson,
      path: "airports",
      label: "Аэропорты",
    },
    {
      icon: MdOutlinePlayLesson,
      path: "users",
      label: "Пользователи",
    },
    {
      icon: MdOutlineEvent,
      path: "devices",
      label: "Устройства",
    },
    {
      icon: MdOutlinePlayLesson,
      path: "duas",
      label: "Список дуа",
    },
    {
      icon: MdOutlinePlayLesson,
      path: "dua-categories",
      label: "Список категорий дуа",
    },
    {
      icon: MdOutlinePlayLesson,
      path: "supports",
      label: "Служба поддержки",
    },
    {
      icon: MdOutlinePlayLesson,
      path: "reminders",
      label: "Напоминание/Новости",
    },
    {
      icon: MdOutlineEvent,
      path: "events",
      label: "Управление событиями",
    },
    {
      icon: MdOutlinePlayLesson,
      path: "amals",
      label: "Амалдар",
    },
    {
      icon: MdOutlinePlayLesson,
      path: "ramadan-diary",
      label: "Рамазан күнделігі",
    },
    {
      icon: MdOutlinePlayLesson,
      path: "app-versions",
      label: "Версии приложений",
    },
    {
      icon: MdOutlinePlayLesson,
      path: "books",
      label: "Книги",
    },
    {
      icon: MdOutlinePlayLesson,
      path: "book-categories",
      label: "Категории книг",
    },
    {
      icon: MdOutlinePlayLesson,
      path: "zikrs",
      label: "Зикры",
    },
    {
      icon: MdOutlinePlayLesson,
      path: "integrations",
      label: "Интеграции",
    },
    {
      icon: MdOutlinePlayLesson,
      path: "permissions",
      label: "Права доступа",
    },
  ];

  const advancedAdminMenu = [
    {
      icon: MdOutlinePlayLesson,
      path: "room-types",
      label: "Типы комнат",
    },
    {
      icon: MdOutlinePlayLesson,
      path: "trigger-types",
      label: "Типы триггеров",
    },
  ];


  const plansAdminMenu = [
    {
      icon: MdOutlinePlayLesson,
      path: "plans/list",
      label: "Тарифы",
    },
    {
      icon: MdOutlinePlayLesson,
      path: "plans/features",
      label: "Функционал тарифа",
    },
  ];


  useEffect(() => {
    document.addEventListener("click", (event) => {
      if (!sidebar.current) {
        return;
      }
      if (!sidebar.current.contains(event.target) && !burger.current.contains(event.target)) {
        sidebar.current.classList.remove("active");
      }
    });
  }, []);

  useEffect(() => {
    sidebar.current.classList.remove("active");
  }, [location]);

  return (
    <div className="page-wrapper" id="main-wrapper">
      <aside className="left-sidebar admin-nav" ref={sidebar}>
        <div className="admin-logo flex items-center">
          Super Admin
        </div>

        <nav className="sidebar-nav">
          <List>
            {menu.map((item, index) => {
              return <div key={index} className="menu-item">
                <ListItemButton component={NavLink} to={item.path} className="sidebar-link">
                  <ListItemIcon sx={{ minWidth: '1.5rem' }}>
                    {item.icon && <item.icon />}
                  </ListItemIcon>
                  <ListItemText primary={item.label}></ListItemText>
                </ListItemButton>
                <div className="sub-menu-wrapper" timeout="auto">
                  {item.children && item.children.map((c, subInx) => {
                    return <List component="div" disablePadding className="sub-menu" key={subInx}>
                      <ListItemButton sx={{ pl: 4 }} component={NavLink} to={c.path}>
                        <ListItemIcon sx={{ minWidth: '1.5rem' }}>
                          {item.icon && <item.icon />}
                        </ListItemIcon>
                        <ListItemText primary={c.label} />
                      </ListItemButton>
                    </List>
                  })}
                </div>
              </div>
            })}
          </List>
          <hr />
          <List>
            {advancedAdminMenu.map((item, index) => {
              return <MenuGroup key={index} item={item} />
            })}
          </List>
          <hr />
          <List>
            {plansAdminMenu.map((item, index) => {
              return <MenuGroup key={index} item={item} />
            })}
          </List>
          <hr />
          <a href="https://docs.google.com/document/d/1JtrZNRnJWAdPcpsFSjtiNmvvUQ_aqiy8Adkcp6lhYuo/edit?usp=sharing" className="sidebar-link" target="_blank">
            <div>
              <MdOutlineModeComment />
              <div>Wiki</div>
            </div>
          </a>
        </nav>
      </aside>
      <section className="admin-content">
        <div className="ml-auto w-max flex">
          <UserMenu
            user={authUser}
            setMobileOpen={() => {
              sidebar.current.classList.toggle("active");
            }}
          />
          <IconButton
            ref={burger}
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={() => {
              sidebar.current.classList.toggle("active");
            }}
            sx={{ display: { sm: "none" } }}
          >
            <FaBars></FaBars>
          </IconButton>
        </div>
        <Breadcrumb />
        <Outlet />
      </section>
    </div>
  );
};

const MenuGroup = ({ item, index }) => {
  return (
    <div className="menu-item">
      <ListItemButton component={NavLink} to={item.path} className="sidebar-link">
        <ListItemIcon sx={{ minWidth: '1.5rem' }}>
          {item.icon && <item.icon />}
        </ListItemIcon>
        <ListItemText primary={item.label}></ListItemText>
      </ListItemButton>
      <div className="sub-menu-wrapper" timeout="auto">
        {item.children && item.children.map((c, subInx) => {
          return <List component="div" disablePadding className="sub-menu" key={subInx}>
            <ListItemButton sx={{ pl: 4 }} component={NavLink} to={c.path}>
              <ListItemIcon sx={{ minWidth: '1.5rem' }}>
                {item.icon && <item.icon />}
              </ListItemIcon>
              <ListItemText primary={c.label} />
            </ListItemButton>
          </List>
        })}
      </div>
    </div>
  )
}

export default withUser(SuperAdminLayout);
